import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneSU_NT_MRI_Patents = createAsyncThunk(
  "SU_NT_MRI_Patents/GetOneSU_NT_MRI_Patents",
  async (patentsId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_Patents/GetOneSU_NT_MRI_Patents",
        {
          patentsId: patentsId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteSU_NT_MRI_Patents = createAsyncThunk(
  "SU_NT_MRI_Patents/DeleteSU_NT_MRI_Patents",
  async (patentsId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_Patents/DeleteSU_NT_MRI_Patents",
        {
          patentsId: patentsId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateSU_NT_MRI_Patents = createAsyncThunk(
  "SU_NT_MRI_Patents/UpdateSU_NT_MRI_Patents",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_Patents/UpdateSU_NT_MRI_Patents",
        {
            patentsId:model.patentsId,
            countryOfRegistrationId: model.countryOfRegistrationId,
            number: model.number,
            link: model.link,
            applicationInformationId: model.applicationInformationId
          }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddSU_NT_MRI_Patents = createAsyncThunk(
  "SU_NT_MRI_Patents/AddSU_NT_MRI_Patents",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_Patents/AddSU_NT_MRI_Patents",
        {
            countryOfRegistrationId: model.countryOfRegistrationId,
            number: model.number,
            link: model.link,
            applicationInformationId: model.applicationInformationId
           
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const Patents = createSlice({
  name: "Patents",
  initialState: {
    Patents: {},
    loadingPatents: false,
    errorPatents: null,

    AddPatents: {},
    loadingAddPatents: false,
    errorAddPatents: null,

    UpdatePatents: {},
    loadingUpdatePatents: false,
    errorUpdatePatents: null,

    DeletePatents: {},
    loadingDeletePatents: false,
    errorDeletePatents: null,

    ListPatents: {},
    loadingListPatents: false,
    errorListPatents: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetOneSU_NT_MRI_Patents.pending, (state, action) => {
        state.loadingPatents = true;
        state.Patents = action.payload;
        state.errorPatents = null;
      })
      .addCase(GetOneSU_NT_MRI_Patents.fulfilled, (state, action) => {
        state.loadingPatents = false;
        state.Patents = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneSU_NT_MRI_Patents.rejected, (state, action) => {
        state.loadingPatents = false;
        state.errorPatents = action.payload;
      })

      .addCase(DeleteSU_NT_MRI_Patents.pending, (state, action) => {
        state.loadingDeletePatents = true;
        state.DeletePatents = action.payload;
        state.errorDeletePatents = null;
      })
      .addCase(DeleteSU_NT_MRI_Patents.fulfilled, (state, action) => {
        state.loadingDeletePatents = false;
        state.DeletePatents = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteSU_NT_MRI_Patents.rejected, (state, action) => {
        state.loadingDeletePatents = false;
        state.errorDeletePatents = action.payload;
      })

      .addCase(UpdateSU_NT_MRI_Patents.pending, (state, action) => {
        state.loadingUpdatePatents = true;
        state.UpdatePatents = action.payload;
        state.errorUpdatePatents = null;
      })
      .addCase(
        UpdateSU_NT_MRI_Patents.fulfilled,
        (state, action) => {
          state.loadingUpdatePatents = false;
          state.UpdatePatents = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(UpdateSU_NT_MRI_Patents.rejected, (state, action) => {
        state.loadingUpdatePatents = false;
        state.errorUpdatePatents = action.payload;
      })

      .addCase(AddSU_NT_MRI_Patents.pending, (state, action) => {
        state.loadingAddPatents = true;
        state.AddPatents = action.payload;
        state.errorAddPatents = null;
      })
      .addCase(AddSU_NT_MRI_Patents.fulfilled, (state, action) => {
        state.loadingAddPatents = false;
        state.AddPatents = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddSU_NT_MRI_Patents.rejected, (state, action) => {
        state.loadingAddPatents = false;
        state.errorAddPatents = action.payload;
      });
  },
});

export default Patents.reducer;
